import { useEffect, useState } from "react";
import { Link } from "react-router";
import { TabBar } from "../components/TabBar";
import { api, apiBlob } from "../api/client";
import { useAuth } from "../auth/AuthProvider";
import type { Profile } from "../api/types";

export const Settings = () => {
  const auth = useAuth();
  const [profile, setProfile] = useState<Profile | null>(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api<Profile>("/me").then(setProfile).catch(() => {});
  }, []);

  const save = async () => {
    if (!profile) return;
    setSaving(true);
    try {
      const updated = await api<Profile>("/me", {
        method: "PUT",
        body: {
          name: profile.name,
          weightGoal: profile.weightGoal,
          units: profile.units,
        },
      });
      setProfile(updated);
    } finally {
      setSaving(false);
    }
  };

  const download = async (path: string, name: string) => {
    const blob = await apiBlob(path);
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <div className="page">
        <h1 className="h1">Settings</h1>
        <div className="muted">{auth.email}</div>

        {profile && (
          <div className="card" style={{ marginTop: 16 }}>
            <label className="field">
              Name
              <input
                value={profile.name}
                onChange={(e) => setProfile({ ...profile, name: e.target.value })}
              />
            </label>
            <label className="field" style={{ marginTop: 12 }}>
              Weight goal (optional)
              <input
                type="number"
                inputMode="decimal"
                value={profile.weightGoal ?? ""}
                onChange={(e) =>
                  setProfile({
                    ...profile,
                    weightGoal: e.target.value === "" ? undefined : Number(e.target.value),
                  })
                }
              />
            </label>
            <label className="field" style={{ marginTop: 12 }}>
              Units
              <select
                value={profile.units}
                onChange={(e) => setProfile({ ...profile, units: e.target.value as "lbs" | "kg" })}
              >
                <option value="lbs">Pounds (lbs)</option>
                <option value="kg">Kilograms (kg)</option>
              </select>
            </label>
            <button className="btn" style={{ marginTop: 16 }} disabled={saving} onClick={() => void save()}>
              {saving ? "Saving…" : "Save"}
            </button>
          </div>
        )}

        <h2 className="h2">Body weight</h2>
        <Link to="/bodyweight" className="btn secondary">Log body weight</Link>

        <h2 className="h2">Schedule</h2>
        <Link to="/schedule" className="btn secondary">Manage weekly plan</Link>

        <h2 className="h2">Progress</h2>
        <Link to="/progress" className="btn secondary">View progress</Link>

        <h2 className="h2">Export</h2>
        <div className="col">
          <button className="btn secondary" onClick={() => void download("/export/sessions.csv", "workout-history.csv")}>
            Download workout history CSV
          </button>
          <button className="btn secondary" onClick={() => void download("/export/bodyweight.csv", "body-weight.csv")}>
            Download body weight CSV
          </button>
        </div>

        {profile?.isAdmin && (
          <>
            <h2 className="h2">Admin</h2>
            <Link to="/admin" className="btn secondary">Manage exercise library</Link>
          </>
        )}

        <h2 className="h2">Account</h2>
        <button className="btn danger" onClick={() => auth.signOut()}>
          Sign out
        </button>
      </div>
      <TabBar />
    </>
  );
};
